import React from 'react';

import { useHealthInformationCms } from './HealthInformationCmsContext';

type Props = {
  children: React.ReactNode;
};

/** Renders children only when CMS page `meta_title=health_information` exists with content for the active language. */
export function HealthInformationCmsGate({ children }: Props) {
  const { isAvailable, isLoading } = useHealthInformationCms();
  if (isLoading || !isAvailable) {
    return null;
  }
  return <>{children}</>;
}
